import { z } from 'zod';

/**
 * Veri İşleyen Sözleşme Kaydı (DPA Registry) — KVKK m.12/2, GDPR Art. 28.
 */

export const DPA_ROLE_VALUES = ['processor', 'joint_controller', 'sub_processor'];
export const DPA_AGREEMENT_TYPE_VALUES = ['dpa', 'scc', 'undertaking', 'bcr', 'other'];
export const DPA_STATUS_VALUES = ['draft', 'active', 'expired', 'terminated'];
export const ART28_CHECKLIST_KEY_VALUES = [
    'documentedInstructions',
    'confidentialityCommitment',
    'securityMeasures',
    'subProcessorConsent',
    'dsrAssistance',
    'breachAssistance',
    'deletionOrReturn',
    'auditRights',
];

const objectId = z.string().regex(/^[a-f\d]{24}$/i, 'Invalid ObjectId');
const dateLike = z.union([z.string(), z.date()]);

export const Art28ChecklistItemSchema = z.object({
    key: z.enum(ART28_CHECKLIST_KEY_VALUES),
    satisfied: z.boolean().default(false),
    note: z.string().optional(),
});

export const DpaSubProcessorSchema = z.object({
    name: z.string().min(1),
    country: z.string().optional(),
    services: z.string().optional(),
    status: z.enum(['pending_approval', 'approved', 'rejected', 'removed']).optional(),
});

export const CreateDataProcessingAgreementSchema = z.object({
    title: z.string().min(1, 'Title is required'),
    description: z.string().optional(),
    vendorId: objectId,
    role: z.enum(DPA_ROLE_VALUES).default('processor'),
    agreementType: z.enum(DPA_AGREEMENT_TYPE_VALUES).default('dpa'),
    art28Checklist: z.array(Art28ChecklistItemSchema).optional(),
    validFrom: dateLike.nullable().optional(),
    validUntil: dateLike.nullable().optional(),
    autoRenew: z.boolean().optional(),
    linkedProcessingActivities: z.array(objectId).optional(),
    transferMechanismId: objectId.nullable().optional(),
    documentId: objectId.nullable().optional(),
    status: z.enum(DPA_STATUS_VALUES).optional(),
    customFields: z.record(z.any()).optional(),
});

export const UpdateDataProcessingAgreementSchema = CreateDataProcessingAgreementSchema.partial();

export const AddDpaSubProcessorSchema = DpaSubProcessorSchema;

export const DecideDpaSubProcessorSchema = z.object({
    decision: z.enum(['approved', 'rejected']),
    note: z.string().optional(),
});
